import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { resetPhotoViewerAction } from 'actions/photo/photoViewerAction'
import { clearPhotoRatingSettingsAction } from 'actions/photoRating/photoRatingSettingsAction'
import { clearPhotosQueueAction } from 'actions/rating/photosNextAction'

export const useClearRatingStore = () => {
  const dispatch = useDispatch()

  /**
   * Удаление результатов
   * после рейтинга после изменения формы поиска
   */
  const clearRatingStore = useCallback(
    (isClearRatingSetting: boolean) => {
      try {
        dispatch(resetPhotoViewerAction())
        dispatch(clearPhotosQueueAction())
        if (isClearRatingSetting) {
          dispatch(clearPhotoRatingSettingsAction())
        }
      } catch (error) {
        console.error(`Не удалось отчистить рейтинг причина - ${error}`)
      }
    },
    [dispatch]
  )

  return {
    clearRatingStore,
  }
}
